<app-tarjeta-info-autor [tipoTarjeta]="tipoTarjeta" [id]="urlBlog"></app-tarjeta-info-autor>
<div class="contenedor-posts">
  @for (item of posts; track item; let i = $index) {
    <app-post-listado class="div{{ i + 1 }} item-noticia" [post]="item" [urlBlog]="urlBlog"></app-post-listado>
  }
</div>
